const SCRIPT_TYPE = 'text/javascript'
const SCRIPT_ID = 'google-recaptcha-script'

export default {
  name: 'CaptchaContainer',
  props: {
    action: {
      type: String,
      required: true
    }
  },
  data: () => ({
    isLoading: true
  }),
  computed: {
    reCAPTCHAKey () {
      return process.env.VUE_APP_GOOGLE_RECAPTCHA_KEY
    },
    isNotLoading () {
      return !this.isLoading
    }
  },
  async mounted () {
    await this.loadScripts()
  },
  methods: {
    async loadScripts () {
      this.isLoading = true
      try {
        await this.loadOrInsertGoogleCaptchaScript()
        await this.waitUntilGoogleReCAPTCHAIsReady()
      } catch (error) {
        console.error('Error while trying to load captcha script: ', error)
      } finally {
        this.isLoading = false
      }
    },
    loadOrInsertGoogleCaptchaScript () {
      return new Promise((resolve, reject) => {
        const existingGoogleReCAPTCHAScript = document.querySelector(
          `#${SCRIPT_ID}`
        )
        if (existingGoogleReCAPTCHAScript) {
          resolve()
        } else {
          const googleRecaptchaScript = this.createGoogleRecaptchaScriptElement()
          googleRecaptchaScript.addEventListener('load', resolve)
          googleRecaptchaScript.addEventListener('error', reject)
          googleRecaptchaScript.addEventListener('abort', reject)

          document.body.appendChild(googleRecaptchaScript)
        }
      })
    },
    waitUntilGoogleReCAPTCHAIsReady () {
      const { grecaptcha } = window
      return new Promise(resolve => {
        grecaptcha.ready(resolve)
      })
    },
    createGoogleRecaptchaScriptElement () {
      const googleRecaptchaScript = document.createElement('script')
      googleRecaptchaScript.id = SCRIPT_ID
      googleRecaptchaScript.type = SCRIPT_TYPE
      googleRecaptchaScript.async = true
      googleRecaptchaScript.src = `https://www.google.com/recaptcha/api.js?render=${this.reCAPTCHAKey}`
      return googleRecaptchaScript
    },
    async generateCaptchaToken () {
      const { action } = this
      const { grecaptcha } = window
      const token = await grecaptcha.execute(this.reCAPTCHAKey, { action })
      return token
    }
  },
  render () {
    return this.$scopedSlots.default({
      generateCaptchaToken: this.generateCaptchaToken,
      isLoading: this.isLoading,
      isNotLoading: this.isNotLoading
    })
  }
}
